import { render, staticRenderFns } from "./navigation-item.vue?vue&type=template&id=5420603a&scoped=true&"
import script from "./navigation-item.vue?vue&type=script&lang=js&"
export * from "./navigation-item.vue?vue&type=script&lang=js&"
import style0 from "./navigation-item.vue?vue&type=style&index=0&id=5420603a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5420603a",
  null
  
)

export default component.exports